module.exports = __webpack_public_path__ + "static/1-9a0406bf27a5f8e158219017df7c2b09.jpg";